if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.scale = 1;
        this.panning = false;
        this.pointX = 0;
        this.pointY = 0;
        this.start = { x: 0, y: 0 };
        this.mql = window.matchMedia('(min-width: 750px)');
      }

      hide() {
        super.hide();
        this.resetZoom();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.setupZoom();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      setupZoom() {
        if (!this.mql.matches) return;
        const activeMedia = this.querySelector('.active');
        if (!activeMedia || activeMedia.tagName !== 'IMG') return;

        this.resetZoom();

        activeMedia.style.transformOrigin = 'center center';
        activeMedia.style.transition = 'transform 0.1s ease-out';
        activeMedia.style.cursor = 'zoom-in';

        this.zoomElement = activeMedia;

        this.wheelHandler = (e) => {
          e.preventDefault();
          const xs = (e.clientX - this.pointX) / this.scale;
          const ys = (e.clientY - this.pointY) / this.scale;
          const delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
          
          if (delta > 0) {
            this.scale = Math.min(3, this.scale + 0.15);
          } else {
            this.scale = Math.max(1, this.scale - 0.15);
          }

          if (this.scale === 1) {
            this.pointX = 0;
            this.pointY = 0;
            activeMedia.style.cursor = 'zoom-in';
          } else {
            this.pointX = e.clientX - xs * this.scale;
            this.pointY = e.clientY - ys * this.scale;
            activeMedia.style.cursor = 'grab';
          }

          this.updateTransform();
        };

        this.mouseDownHandler = (e) => {
          if (this.scale <= 1) return;
          e.preventDefault();
          this.panning = true;
          this.zoomElement.style.transition = 'none';
          this.zoomElement.style.cursor = 'grabbing';
          this.start = { x: e.clientX - this.pointX, y: e.clientY - this.pointY };
        };

        this.mouseUpHandler = (e) => {
          this.panning = false;
          if (this.zoomElement) {
            this.zoomElement.style.transition = 'transform 0.1s ease-out';
            this.zoomElement.style.cursor = this.scale > 1 ? 'grab' : 'zoom-in';
          }
        };

        this.mouseMoveHandler = (e) => {
          if (!this.panning) return;
          this.pointX = e.clientX - this.start.x;
          this.pointY = e.clientY - this.start.y;
          this.updateTransform();
        };

        this.pointerUpHandler = (e) => {
          if (this.scale > 1) {
            e.stopPropagation();
          }
        };

        this.zoomElement.addEventListener('wheel', this.wheelHandler, { passive: false });
        this.zoomElement.addEventListener('mousedown', this.mouseDownHandler);
        this.zoomElement.addEventListener('pointerup', this.pointerUpHandler);
        window.addEventListener('mouseup', this.mouseUpHandler);
        window.addEventListener('mousemove', this.mouseMoveHandler);
      }

      updateTransform() {
        if (!this.zoomElement) return;
        this.zoomElement.style.transform = `translate(${this.pointX}px, ${this.pointY}px) scale(${this.scale})`;
        
        const container = this.querySelector('.product-media-modal__content');
        if (container) {
          if (this.scale > 1) {
            container.style.overflow = 'hidden';
          } else {
            container.style.overflow = 'auto';
          }
        }
      }

      resetZoom() {
        if (this.zoomElement) {
          this.zoomElement.removeEventListener('wheel', this.wheelHandler);
          this.zoomElement.removeEventListener('mousedown', this.mouseDownHandler);
          this.zoomElement.removeEventListener('pointerup', this.pointerUpHandler);
          window.removeEventListener('mouseup', this.mouseUpHandler);
          window.removeEventListener('mousemove', this.mouseMoveHandler);
          this.zoomElement.style.transform = '';
          this.zoomElement.style.transformOrigin = '';
          this.zoomElement.style.transition = '';
          this.zoomElement.style.cursor = '';
          this.zoomElement = null;
        }
        this.scale = 1;
        this.panning = false;
        this.pointX = 0;
        this.pointY = 0;
        const container = this.querySelector('.product-media-modal__content');
        if (container) container.style.overflow = '';
      }
    }
  );
}
